import React, {useState} from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import AppWrapper from './components/app-wrapper';
import {MenuProvider} from './contexts/menu-context';
import DashboardPage from '../pages/dashboard-page';
import ArticlesPage from '../pages/articles-page';
import ArticleFormPage from '@pages/article-form-page';
import SpecialistsPage from '../pages/specialists-page';
import AuthorsPage from '../pages/authors-page';
import SettingsPage from '../pages/settings-page';
import AppMenu from "./app-menu";
import MobileHeader from './components/mobile-header';
import MobileSidebar from './components/mobile-sidebar';
import {ArticleFormProvider} from "../features/articles/contexts/article-form-context";
import {AppMetadataProvider} from "../features/core/contexts/app-metadata-context";

const MainLayer: React.FC = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleMenuToggle = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const handleMenuClose = () => {
        setIsMobileMenuOpen(false);
    };

    return (
        <MenuProvider>
            <ArticleFormProvider>
                <AppMetadataProvider>
                    <div className="w-full bg-white h-svh max-h-screen overflow-hidden">
                    <MobileHeader
                        onMenuToggle={handleMenuToggle}
                        isMenuOpen={isMobileMenuOpen}
                    />

                    <MobileSidebar
                        isOpen={isMobileMenuOpen}
                        onClose={handleMenuClose}
                    />

                    <div className="flex h-[calc(100vh-4rem)] lg:h-full">
                        <div className="hidden lg:block">
                            <AppMenu/>
                        </div>
                        <AppWrapper className="flex w-full">
                            <Routes>
                                <Route index element={<DashboardPage/>}/>
                                <Route path="/articles" element={<ArticlesPage/>}/>
                                <Route path="/articles/new" element={<ArticleFormPage/>}/>
                                <Route path="/articles/edit/:id" element={<ArticleFormPage/>}/>
                                <Route path="/specialists" element={<SpecialistsPage/>}/>
                                <Route path="/authors" element={<AuthorsPage/>}/>
                                <Route path="/settings" element={<SettingsPage/>}/>
                                <Route path="*" element={<Navigate to="/not-found"/>}/>
                            </Routes>
                        </AppWrapper>
                    </div>
                </div>
                </AppMetadataProvider>
            </ArticleFormProvider>
        </MenuProvider>
    );
};

export default MainLayer;
